'use client'

// Feeds the marketing site's calls to action into the platform's existing
// tracking (GA4, Meta, TikTok and LinkedIn through lib/tracking), the same
// events the previous site fired: Calendly bookings, email, downloads and CTAs.
import { useEffect } from 'react'
import { trackCalendlyClick, trackCTAClick } from '@/lib/tracking'

export function SiteTracking() {
  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      const a = (e.target as Element | null)?.closest?.('.behmn-site a[href]') as HTMLAnchorElement | null
      if (!a) return
      const href = a.getAttribute('href') || ''
      const label = (a.textContent || a.getAttribute('aria-label') || '').replace(/\s+/g, ' ').trim()
      if (/calendly\.com/.test(href)) trackCalendlyClick(label || 'discovery-call')
      else if (href.startsWith('mailto:')) trackCTAClick(label || 'email', href.split('?')[0])
      else if (/\.pdf(\?|$)/.test(href)) trackCTAClick(label || 'download', href)
      else if (a.classList.contains('btn')) trackCTAClick(label, href)
    }
    document.addEventListener('click', onClick, { capture: true })
    return () => document.removeEventListener('click', onClick, { capture: true })
  }, [])
  return null
}
